import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getDirectorate(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}

export async function createDirectorate(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/directorate" + pathname, body);
}

export async function updateDirectorate(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/directorate" + pathname, body);
}

export async function deleteDirectorate(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).delete("/directorate" + pathname, { data: body });
}
